import React, { useState } from 'react';
import { TimeRangePickerProps } from '../types';
import { QUICK_OPTIONS } from '../constants';
import { toLocalDateTimeString } from '../helpers';

export function TimeRangePicker({ label, onSelect, onCancel }: TimeRangePickerProps) {
  const now = new Date();
  const defaultStart = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);

  const [startDate, setStartDate] = useState(toLocalDateTimeString(defaultStart));
  const [endDate, setEndDate] = useState(toLocalDateTimeString(now));

  const handleCustomSubmit = () => {
    const start = new Date(startDate).getTime();
    const end = new Date(endDate).getTime();
    if (start && end && end > start) {
      onSelect(start, end);
    }
  };

  return (
    <div className="rv-time-range-picker">
      <div className="rv-time-range-header">
        <span>Select time range for <strong>{label}</strong></span>
        <button className="rv-time-range-cancel" onClick={onCancel} aria-label="Cancel">✕</button>
      </div>

      {/* Quick options */}
      <div className="rv-time-range-quick">
        {QUICK_OPTIONS.map((opt) => (
          <button
            key={opt.label}
            className="rv-time-range-btn"
            onClick={() => onSelect(Date.now() - opt.ms, Date.now())}
          >
            {opt.label}
          </button>
        ))}
      </div>

      {/* Custom date range */}
      <div className="rv-time-range-custom">
        <div className="rv-time-range-field">
          <label htmlFor="rv-start-date">Start</label>
          <input
            id="rv-start-date"
            type="datetime-local"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </div>
        <div className="rv-time-range-field">
          <label htmlFor="rv-end-date">End</label>
          <input
            id="rv-end-date"
            type="datetime-local"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
        <button className="rv-time-range-apply" onClick={handleCustomSubmit}>
          Apply
        </button>
      </div>
    </div>
  );
}
